import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { AiPmSuggestionDto } from './pm-ai.models';

@Injectable({ providedIn: 'root' })
export class PmAiApiService {
  private readonly api = inject(ApiService);
  private readonly base = 'v1/pm/ai';

  suggestTasks(projectId: string, prompt: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/tasks/suggest`, { projectId, prompt });
  }

  generateStory(projectId: string, brief: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/stories/generate`, { projectId, brief });
  }

  acceptanceCriteria(issueId: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/issues/${issueId}/acceptance-criteria`, {});
  }

  predictRisk(issueId: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/issues/${issueId}/predict-risk`, {});
  }

  predictDeadline(issueId: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/issues/${issueId}/predict-deadline`, {});
  }

  duplicates(issueId: string): Observable<AiPmSuggestionDto> {
    return this.api.get<AiPmSuggestionDto>(`${this.base}/issues/${issueId}/duplicates`);
  }

  dailySummary(projectId: string): Observable<AiPmSuggestionDto> {
    return this.api.get<AiPmSuggestionDto>(`${this.base}/projects/${projectId}/daily-summary`);
  }

  weeklyReport(projectId: string): Observable<AiPmSuggestionDto> {
    return this.api.get<AiPmSuggestionDto>(`${this.base}/projects/${projectId}/weekly-report`);
  }

  standup(projectId: string): Observable<AiPmSuggestionDto> {
    return this.api.get<AiPmSuggestionDto>(`${this.base}/projects/${projectId}/standup`);
  }

  planSprint(sprintId: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/sprints/${sprintId}/plan`, {});
  }

  releaseNotes(versionId: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/versions/${versionId}/release-notes`, {});
  }

  categorizeBug(issueId: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/issues/${issueId}/categorize-bug`, {});
  }

  apply(suggestionId: string): Observable<AiPmSuggestionDto> {
    return this.api.post<AiPmSuggestionDto>(`${this.base}/suggestions/${suggestionId}/apply`, {});
  }
}
